import { isValidPhoneNumber, formatPhoneNumber, isPossiblePhoneNumber } from "react-phone-number-input";
import { AutoClaimReport, GeneralLiabilityClaimReport, Claim } from "./Models/Claim";
import { AutoClaim } from "./Components/ClaimForms/AutoClaim";
export const ByteLimit = 9437184;
export const EmailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export function ValidateEmail(email:string)
{
    return EmailRegex.test(email);
}

export function FixDate(date:Date): Date
{
    if (!date)
         return null as any;
    let fixedDate = new Date(date);
    fixedDate.setUTCMonth(date.getMonth());
    fixedDate.setUTCDate(date.getDate());
    fixedDate.setUTCMinutes(date.getMinutes());
    fixedDate.setUTCHours(date.getHours());
    fixedDate.setUTCMilliseconds(0);
    return fixedDate;
}

export function PrettyPrintDate(date: Date): string
{
	let hours = date.getUTCHours();
	let minutes = date.getUTCMinutes();
	let realMinutes = "";
	let isPm = false;
	if (hours >=12)
	{
		isPm = true;
		if (hours >=13)
			hours = hours - 12;
	}
	if (hours === 0)
		hours = 12;
	if (minutes < 10)
		realMinutes = `0${minutes}`;
	else realMinutes = minutes.toString();
	return `${date.getUTCMonth() + 1}/${date.getUTCDate()}/${date.getUTCFullYear()} ${hours}:${realMinutes} ${isPm ? "PM": "AM"}`;
}

export function AfterToolTipShow()
{
    let dom = document.getElementById("learn-more-tip");
    dom!.setAttribute("aria-hidden","false");
}

export function AfterToolTipHide()
{
    let dom = document.getElementById("learn-more-tip");
    dom!.setAttribute("aria-hidden","true");
}

export function CloneAutoClaim(claim: AutoClaimReport)
{
        var autoClaim = new AutoClaimReport();
        autoClaim.claimNumber = claim.claimNumber;
        autoClaim.policyNumber = claim.policyNumber
        autoClaim.type = claim.type;
        autoClaim.websiteId = claim.websiteId;
        autoClaim.lossDate = claim.lossDate;
		autoClaim.lossLocation = claim.lossLocation;
		autoClaim.line1 = claim.line1;
		autoClaim.city = claim.city;
		autoClaim.state = claim.state;
		autoClaim.zipCode = claim.zipCode;
		autoClaim.policyName = claim.policyName;
		autoClaim.primaryPhone = claim.primaryPhone;
		autoClaim.altPhone = claim.altPhone;
		autoClaim.email = claim.email;
		autoClaim.additionalAnswers["altContactRelation"] = claim.additionalAnswers["altContactRelation"];
		autoClaim.additionalAnswers["altContactName"] = claim.additionalAnswers["altContactName"];
		autoClaim.additionalAnswers["altContactPhone"] = claim.additionalAnswers["altContactPhone"];
		autoClaim.additionalAnswers["altContactEmail"] = claim.additionalAnswers["altContactEmail"];
		autoClaim.bestContactName = claim.bestContactName;
		autoClaim.bestContactPhone = claim.bestContactPhone;
		autoClaim.bestContactAltPhone = claim.bestContactAltPhone;
        autoClaim.explanation = claim.explanation;
		autoClaim.policyHolderVehicleYear = claim.policyHolderVehicleYear;
		autoClaim.policyHolderVehicleModel = claim.policyHolderVehicleModel;
		autoClaim.policyHolderVehicleMake = claim.policyHolderVehicleMake;
		autoClaim.policyHolderVehicleVIN = claim.policyHolderVehicleVIN;
		autoClaim.policyHolderDriver = claim.policyHolderDriver;
		autoClaim.driverName = claim.driverName;
		autoClaim.isVehicleDrivable = claim.isVehicleDrivable;
		autoClaim.pointOfImpact = claim.pointOfImpact;
		autoClaim.didAirbagsDeploy = claim.didAirbagsDeploy;
		autoClaim.vehicleLocation = claim.vehicleLocation;
        autoClaim.otherPropertyDamage = claim.otherPropertyDamage;
        autoClaim.otherPropertyDescription = claim.otherPropertyDescription;
        autoClaim.otherPropertyVehicleMake = claim.otherPropertyVehicleMake;
        autoClaim.otherPropertyVehicleYear = claim.otherPropertyVehicleYear;
        autoClaim.otherPropertyVehicleModel = claim.otherPropertyVehicleModel;
        autoClaim.otherPropertyVehicleVIN = claim.otherPropertyVehicleVIN;
        autoClaim.otherPropertyOwnersName = claim.otherPropertyOwnersName;
        autoClaim.otherPropertyOwnersAddress = claim.otherPropertyOwnersAddress;
        autoClaim.otherPropertyOwnersPhone = claim.otherPropertyOwnersPhone;
        autoClaim.otherPropertyOwnersAltPhone = claim.otherPropertyOwnersAltPhone;
        autoClaim.otherPropertyOwnersCompAgency = claim.otherPropertyOwnersCompAgency;
        autoClaim.otherPropertyOwnersPolicy = claim.otherPropertyOwnersPolicy;
        autoClaim.otherPropertyVehicleDriverName = claim.otherPropertyVehicleDriverName;
        autoClaim.otherPropertyDamageDescription = claim.otherPropertyDamageDescription;
        autoClaim.otherPropertyDamageAmount = claim.otherPropertyDamageAmount;
        autoClaim.otherPropertyDamageLocation = claim.otherPropertyDamageLocation;
        autoClaim.areInjuries = claim.areInjuries;
		autoClaim.areWitnessPassengers = claim.areWitnessPassengers;
		autoClaim.additionalAnswers["injuryOneName"] = claim.additionalAnswers["injuryOneName"];
		autoClaim.additionalAnswers["injuryOnePhone"] = claim.additionalAnswers["injuryOnePhone"];
		autoClaim.additionalAnswers["injuryOneLocation"] = claim.additionalAnswers["injuryOneLocation"];
		autoClaim.additionalAnswers["injuryOneDescription"] = claim.additionalAnswers["injuryOneDescription"];
		autoClaim.additionalAnswers["injuryTwoName"] = claim.additionalAnswers["injuryTwoName"];
		autoClaim.additionalAnswers["injuryTwoPhone"] = claim.additionalAnswers["injuryTwoPhone"];
		autoClaim.additionalAnswers["injuryTwoLocation"] = claim.additionalAnswers["injuryTwoLocation"];
		autoClaim.additionalAnswers["injuryTwoDescription"] = claim.additionalAnswers["injuryTwoDescription"];
		autoClaim.additionalAnswers["witnessOneName"] = claim.additionalAnswers["witnessOneName"];
		autoClaim.additionalAnswers["witnessOnePhone"] = claim.additionalAnswers["witnessOnePhone"];
		autoClaim.additionalAnswers["witnessOneLocation"] = claim.additionalAnswers["witnessOneLocation"];
		autoClaim.additionalAnswers["witnessOnePassenger"] = claim.additionalAnswers["witnessOnePassenger"]; 
		autoClaim.additionalAnswers["witnessTwoName"] = claim.additionalAnswers["witnessTwoName"];
		autoClaim.additionalAnswers["witnessTwoPhone"] = claim.additionalAnswers["witnessTwoPhone"];
		autoClaim.additionalAnswers["witnessTwoLocation"] = claim.additionalAnswers["witnessTwoLocation"];
		autoClaim.additionalAnswers["witnessTwoPassenger"] = claim.additionalAnswers["witnessTwoPassenger"]; 
        autoClaim.remarks = claim.remarks;
        return autoClaim;
}

export function CloneGeneralLiabilityClaim(claim: GeneralLiabilityClaimReport) {

	var generalLiabilityClaim = new GeneralLiabilityClaimReport();

	generalLiabilityClaim.claimNumber = claim.claimNumber;
	generalLiabilityClaim.policyNumber = claim.policyNumber
	generalLiabilityClaim.type = claim.type;
	generalLiabilityClaim.websiteId = claim.websiteId;
	generalLiabilityClaim.lossDate = claim.lossDate;
	generalLiabilityClaim.line1 = claim.line1;
	generalLiabilityClaim.city = claim.city;
	generalLiabilityClaim.state = claim.state;
	generalLiabilityClaim.zipCode = claim.zipCode;
	generalLiabilityClaim.policyName = claim.policyName;
	generalLiabilityClaim.primaryPhone = claim.primaryPhone;
	generalLiabilityClaim.altPhone = claim.altPhone;
	generalLiabilityClaim.email = claim.email;
	generalLiabilityClaim.additionalAnswers["altContactRelation"] = claim.additionalAnswers["altContactRelation"];
	generalLiabilityClaim.additionalAnswers["altContactName"] = claim.additionalAnswers["altContactName"];
	generalLiabilityClaim.additionalAnswers["altContactPhone"] = claim.additionalAnswers["altContactPhone"];
	generalLiabilityClaim.additionalAnswers["altContactEmail"] = claim.additionalAnswers["altContactEmail"];
	generalLiabilityClaim.bestContactName = claim.bestContactName;
	generalLiabilityClaim.bestContactPhone = claim.bestContactPhone;
	generalLiabilityClaim.bestContactAltPhone = claim.bestContactAltPhone;
	generalLiabilityClaim.explanation = claim.explanation;
	generalLiabilityClaim.lossLocation = claim.lossLocation;
	generalLiabilityClaim.isLawsuitFiled = claim.isLawsuitFiled;
	generalLiabilityClaim.occuranceType = claim.occuranceType;
	generalLiabilityClaim.propertyDescription = claim.propertyDescription;
	generalLiabilityClaim.propertyOwnerName = claim.propertyOwnerName;
	generalLiabilityClaim.propertyOwnerAddress = claim.propertyOwnerAddress;
	generalLiabilityClaim.propertyOwnersPrimaryPhone = claim.propertyOwnersPrimaryPhone;
	generalLiabilityClaim.propertyOwnersAlternatePhone = claim.propertyOwnersAlternatePhone;
	generalLiabilityClaim.propertyOwnersEmail = claim.propertyOwnersEmail;
	generalLiabilityClaim.propertyDamageAmount = claim.propertyDamageAmount;
	generalLiabilityClaim.injuryDescription = claim.injuryDescription;
	generalLiabilityClaim.injuredPersonsName = claim.injuredPersonsName;
	generalLiabilityClaim.injuredPersonsAddress = claim.injuredPersonsAddress;
	generalLiabilityClaim.injuredPersonsPrimaryPhone = claim.injuredPersonsPrimaryPhone;
	generalLiabilityClaim.injuredPersonsAlternatePhone = claim.injuredPersonsAlternatePhone;
	generalLiabilityClaim.injuredPersonsEmail = claim.injuredPersonsEmail;
	generalLiabilityClaim.areWitnesses = claim.areWitnesses;
	generalLiabilityClaim.witnessName = claim.witnessName;
	generalLiabilityClaim.witnessAddress = claim.witnessAddress;
	generalLiabilityClaim.witnessPrimaryPhone = claim.witnessPrimaryPhone;
	generalLiabilityClaim.witnessAlternatePhone = claim.witnessAlternatePhone;
	generalLiabilityClaim.witnessEmail = claim.witnessEmail;
	generalLiabilityClaim.remarks = claim.remarks;

	return generalLiabilityClaim;

}
